import { createFileRoute, redirect } from '@tanstack/react-router';

/** The product home is the Deal Intelligence library. */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/deal-intelligence' });
  },
});
